export default function copyCode(code: string) {
    navigator.clipboard.writeText(code);
}
